import React from 'react'
import {Link} from 'react-router-dom';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, {textFilter, numberFilter, Comparator, dateFilter} from 'react-bootstrap-table2-filter';
import ToolkitProvider, {
    CSVExport,
    ColumnToggle
} from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import paginationFactory, {
    PaginationProvider,
    PaginationTotalStandalone,
    PaginationListStandalone
} from 'react-bootstrap-table2-paginator';
import Button from 'react-bootstrap/Button';
import Moment from "moment";
import {JsonToTable} from "react-json-to-table";
import * as ROUTES from '../../constants/routes';

const MyExportCSV = (props) => {
    const handleClick = () => {
        props.onExport();
    };
    return (
        <button className="btn btn-success" onClick={handleClick}>
            Export Visible Data
        </button>
    );
};
const {ToggleList} = ColumnToggle;

export const Campaigns = ({campaigns, loadWhoUsedCampaign, loadWhoSeenCampaign, exportRawButton, companyUid}) => {
    const columns = [
        {
            dataField: 'index',
            text: 'Index',
            sort: true
        },
        {
            dataField: 'image',
            text: 'Image',
            formatter: imageFormatter
        },
        {
            dataField: 'id',
            text: 'Id',
            hidden: false,
            formatter: idFormatter,
            csvFormatter: idCSVFormatter,
            filter: textFilter(),
            filterValue: (cell) => cell?.id || ''
        },
        {
            dataField: 'userList',
            text: 'Sent',
            hidden: true
        },
        {
            dataField: 'campaignType',
            text: 'Type',
            sort: true,
            filter: textFilter()
        },
        {
            dataField: 'activeInLastValue',
            text: 'Active In Last',
            sort: true,
            hidden: true
        },
        {
            dataField: 'inactiveInLastValue',
            text: 'Inactive In Last',
            sort: true,
            hidden: true
        },
        {
            dataField: 'spentLessThanValue',
            text: 'Spent Less Than',
            sort: true,
            hidden: true
        },
        {
            dataField: 'spentMoreThanValue',
            text: 'Spent More Than',
            sort: true,
            hidden: true
        },
        {
            dataField: 'visitedLessThanValue',
            text: 'Visited Less Than',
            sort: true,
            hidden: true
        },
        {
            dataField: 'visitedMoreThanValue',
            text: 'Visited More Than',
            sort: true,
            hidden: true
        },
        {
            dataField: 'city',
            text: 'City',
            sort: true,
            filter: textFilter(),
            hidden: true
        },
        {
            dataField: 'storeId',
            text: 'Store Id',
            sort: true,
            filter: textFilter(),
            hidden: true
        },
        {
            dataField: 'offerValue',
            text: 'Offer',
            sort: true,
            style: {
                'overflow-wrap': 'break-word',
                'max-width': '300px'
            }
        },
        {
            dataField: 'numberOfUserToTarget',
            text: 'Targeted',
            filter: numberFilter(),
            sort: true
        },
        {
            dataField: 'likes',
            text: 'Likes',
            sort: true,
            hidden: true,
            formatter: arrayFormatter,
            csvFormatter: arrayCsvFormatter
        },
        {
            dataField: 'dislikes',
            text: 'Dislikes',
            sort: true,
            hidden: true,
            formatter: arrayFormatter,
            csvFormatter: arrayCsvFormatter
        },
        {
            dataField: 'timestamp',
            text: 'Date',
            sort: true,
            formatter: dateFormatter,
            csvFormatter: dateFormatter
        },
        {
            dataField: 'userTotal',
            text: 'Eligible for receiving',
            filter: numberFilter({
                defaultValue: {number: 0, comparator: Comparator.GT}
            })
        },
        {
            dataField: 'userCountNotificationEnabled',
            text: 'Notification On',
            filter: numberFilter({
                defaultValue: {number: 0, comparator: Comparator.GT}
            })
        },
        {
            dataField: 'userCountNotificationDisabled',
            text: 'Notification Off',
            filter: numberFilter({
                defaultValue: {number: 0, comparator: Comparator.GT}
            })
        },
        {
            dataField: 'userDoesNotHaveToken',
            text: 'No token',
            filter: numberFilter({
                defaultValue: {number: 0, comparator: Comparator.GT}
            })
        },
        {
            dataField: 'userReceivedNotificationRecently',
            text: 'Recived Notif Recently',
            filter: numberFilter({
                defaultValue: {number: 0, comparator: Comparator.GT}
            })
        },
        {
            dataField: 'campaignCost',
            text: 'Cost',
            filter: numberFilter({
                defaultValue: {number: 0, comparator: Comparator.GT}
            })
        }
    ];

    function idFormatter(cell, row) {
        let html = [];
        html.push(
            <div>
                <Link
                    to={`${ROUTES.CAMPAIGN_DETAILS}/${companyUid}/${cell.id}`}
                    className="text-blue-600 hover:underline font-mono text-sm"
                >
                    {cell.id}
                </Link>
                <br/>
                <Button variant="warning" size="sm" className="mt-1" onClick={() => loadWhoUsedCampaign(cell.id)}>Show Who Used It</Button><br/>
                <Button variant="secondary" size="sm" className="mt-1" onClick={() => loadWhoSeenCampaign(cell.id)}>Show Who Seen It</Button>
            </div>
        )
        if (cell.whoUsed) {
            if (Object.keys(cell.whoUsed).length > 0) {
                html.push(
                    <div>
                        Used by: {Object.keys(cell.whoUsed).length} <br/>
                        <JsonToTable json={cell.whoUsed}/><br/>
                    </div>
                )
            } else {
                html.push(
                    <div>
                        Used by: {Object.keys(cell.whoUsed).length} <br/>
                    </div>
                )
            }
        }
        if (cell.whoSeen) {
            if (Object.keys(cell.whoSeen).length > 0) {
                html.push(
                    <div>
                        Seen by: {Object.keys(cell.whoSeen).length} <br/>
                        <JsonToTable json={cell.whoSeen}/><br/>
                    </div>
                )
            } else {
                html.push(
                    <div>
                        Seen by: {Object.keys(cell.whoSeen).length} <br/>
                    </div>
                )
            }
        }
        const element = document.activeElement
        console.log(element);
        return (
            <div>
                {html}
            </div>
        )
    }

    function idCSVFormatter(cell, row) {
        return cell.id;
    }

    function dateFormatter(cell, row) {
        return Moment.tz(cell, 'Europe/Belgrade').format('DD.MM.YYYY HH:mm');
    }

    function imageFormatter(cell, row) {
        return (<img style={{width: 100}} src={cell}/>)
    }

    function arrayCsvFormatter(cell, row) {
        const listItems = cell.map((item) => item.uid).join(",");
        return listItems;
    }

    function arrayFormatter(cell, row) {
        var size = 0;
        var listItems = [];
        if (cell) {
            size = cell.length
            listItems = cell.map((item) => {
                    if (item) {
                        return (
                            <OverlayTrigger placement="left"
                                            delay={{show: 250, hide: 400}}
                                            overlay={
                                                <Tooltip id="button-tooltip-{item.uid}-{row}">
                                                    uid: {item.uid}<br/>
                                                    name: {item.firstName}<br/>
                                                    gender: {item.gender}<br/>
                                                    birthday: {item.birthday}<br/>
                                                    visits: {item.count}<br/>
                                                    value: {item.value}<br/>
                                                    bonuses: {item.periodFilled}<br/>
                                                    list of cities: {item.listOfCities}<br/>
                                                    list of company code: {item.listOfCompanyCodes}<br/>
                                                    list of stores: {item.listOfStoresId}<br/>
                                                    last visit: {item.date} {item.time}
                                                </Tooltip>
                                            }
                            >
                                <div style={{cursor: "pointer", color: "blue"}}>{item.uid}</div>
                            </OverlayTrigger>
                        )
                    }
                }
            );
        }
        return (<p><b>Count: {size}</b> <br/> {listItems}</p>)
    }

    const rowEvents = {
        onClick: (e, row, rowIndex) => {
            // alert("Row index: " + (rowIndex + 1));
        }
    };

    const options = {
        sizePerPageList: [{text: '50', value: 50}, {text: '100', value: 100}, {text: '250', value: 250}, {
            text: 'All',
            value: campaigns.length
        }],
        showTotal: true
    }
    return (
        <ToolkitProvider
            keyField='index'
            data={campaigns}
            columns={columns}
            columnToggle
            pagination={paginationFactory(options)}
            exportCSV={{
                exportAll: false,
                onlyExportFiltered: true
            }}>
            {props => (
                <div className="table-card">
                    {/* Table Actions */}
                    <div className="table-actions">
                        <div className="flex flex-wrap items-center gap-3">
                            <MyExportCSV {...props.csvProps}/>
                            {exportRawButton}
                        </div>
                    </div>

                    {/* Column Toggle */}
                    <div className="column-toggle-section">
                        <p className="column-toggle-label">Show/Hide Columns:</p>
                        <ToggleList {...props.columnToggleProps} />
                    </div>

                    {/* Table */}
                    <div className="table-responsive">
                        <BootstrapTable striped bordered hover {...props.baseProps}
                                        pagination={paginationFactory(options)}
                                        rowEvents={rowEvents}
                                        bootstrap4={true}
                                        tabIndexCell
                                        filter={filterFactory()}
                        />
                    </div>
                </div>
            )
            }
        </ToolkitProvider>
    )
}